import { Component, computed, inject, signal } from '@angular/core';
import { NotificationService } from '../../../core/services/notification.service';

/**
 * Sino de notificações + dropdown. Contador e itens vêm de NotificationService
 * (stub — feed real ainda não existe, ver issue #45).
 */
@Component({
  selector: 'app-notification-menu',
  standalone: true,
  imports: [],
  templateUrl: './notification-menu.component.html',
  styleUrl: './notification-menu.component.scss',
})
export class NotificationMenuComponent {
  private readonly notificationService = inject(NotificationService);

  readonly items = this.notificationService.items;
  readonly unreadCount = this.notificationService.unreadCount;
  /** Limite visual do badge — "9+" acima de 9, "99+" acima de 99. */
  readonly badgeLabel = computed(() => {
    const count = this.unreadCount();
    if (count > 99) return '99+';
    if (count > 9) return '9+';
    return String(count);
  });

  readonly open = signal(false);

  toggle(): void {
    this.open.update(v => !v);
  }

  close(): void {
    this.open.set(false);
  }
}
